import ProjectPhotos from '~/javascripts/components/User/ProfileMap/ProjectPhotos';
import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';

const ProjectDetailsCard = observer(
  ({ isFirstProject, project, projectPhotoUrls }) => {
    const wpsOrSponsoredFundingSourceHtml = () => (
      <>
        <h4 className='h80 text-strong-heading font-mono text-grey-50 mt-nudge'>
          {project.contribution_date}
        </h4>
        <p className='mt-nudge'>
          {project.recognizable_type == 'donation'
            ? `${store.projectDetailsMap.userName} fully funded this project with a
          generous donation.`
            : `${store.projectDetailsMap.userName} sponsored this project with their
          fundraising campaign, ${project.campaign_name}.`}
        </p>
      </>
    );

    const campaignerIsProfileOwner = () =>
      project.campaigner_id == project.user_id;

    const d2pFundingSourceHtml = () => (
      <>
        <h4 className='h80 text-strong-heading font-mono text-grey-50 mt-nudge'>
          {project.contribution_date}
        </h4>
        <p className='mt-nudge'>
          {store.projectDetailsMap.userName} partially funded this project with{' '}
          {!campaignerIsProfileOwner() && (
            <>
              <span>
                a donation to {project.campaigner_name}&apos;s campaign,{' '}
              </span>
              <a
                className='text-cw-black font-normal'
                href={`\/${project.campaigner_slug}\/${project.campaign_slug}`}
                rel='noopener noreferrer'
                target='_blank'
              >
                {project.campaign_name}
              </a>
              .
            </>
          )}
          {campaignerIsProfileOwner() && (
            <>
              <span>their fundraising campaign, </span>
              <a
                className='text-cw-black font-normal'
                href={`\/${project.campaigner_slug}\/${project.campaign_slug}`}
                rel='noopener noreferrer'
                target='_blank'
              >
                {project.campaign_name}
              </a>
              .
            </>
          )}
        </p>
      </>
    );

    const projectDetailsPagePath = () => {
      if (project.recognizable_type) {
        return `/projects/${project.short_code}?${project.recognizable_type}_id=${project.recognizable_id}`;
      }
      return `/projects/${project.short_code}`;
    };

    return (
      <div
        className='swiper-slide'
        data-id={project.id}
        data-lat={project.latitude}
        data-lon={project.longitude}
        data-name={project.name}
        data-zoom='4.5'
      >
        <div className='slide-inner relative block text-left box-border'>
          <div className='flex justify-between pt-2 px-2'>
            <div className='p-1 pb-2'>
              <h3 className='h50 text-kazimir mb-nudge font-normal'>
                {project.name}
              </h3>
              <div className='flex flex-wrap justify-start items-start gap-1 md-gap-4'>
                <p className='h80 font-mono'>
                  <i className='icon cw-icon-location text-cw-yellow' />
                  {project.coordinates}
                </p>
                <div className='flex justify-start'>
                  <i className='icon cw-icon-man-3 text-grey-40' />
                  <p className='h80 font-mono'>{project.people_served}</p>
                </div>
              </div>
            </div>
            {project.project_category == 'wps' && <div className='wps-badge' />}
          </div>
          {!window.isMobile && (
            <ProjectPhotos
              isFirstProject={isFirstProject}
              project={project}
              projectPhotoUrls={projectPhotoUrls}
            />
          )}
          {['wps', 'sponsored'].includes(project.project_category) && (
            <div className='funding-source mt-2 mx-2'>
              {wpsOrSponsoredFundingSourceHtml()}
            </div>
          )}
          {project.project_category == 'd2p' && (
            <div className='funding-source mt-2 mx-2'>
              {d2pFundingSourceHtml()}
            </div>
          )}
          <div className='project-details mt-2 mb-2 mx-2'>
            <h4 className='h80 text-strong-heading mt-nudge font-mono text-grey-50'>
              {project.formatted_publish_date}
            </h4>
            <p className='mt-nudge'>
              {project.partner} implemented a {project.water_inventory_type},
              bringing clean and safe drinking water to{' '}
              <span className='font-medium'>
                {project.people_served} people
              </span>{' '}
              in {project.name},{' '}
              {store.projectDetailsMap.countryNameFromCode(
                project.country_code
              )}
              .
            </p>
          </div>
          <div
            className='project-page-link bottom-0 left-0 w-full border-solid border-l-0 border-r-0 border-b-0 border-grey-30'
            style={{ borderWidth: '1px' }}
          >
            <a
              className='flex justify-between items-center no-underline font-normal text-cw-black px-2 py-1'
              href={projectDetailsPagePath()}
              rel='noopener noreferrer'
              target='_blank'
            >
              <p>View full project details</p>
              <i className='cw-icon-open' />
            </a>
          </div>
        </div>
      </div>
    );
  }
);

export default ProjectDetailsCard;
